import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";
import { getTableLabels } from "./tableLabels";
import type { IntlShape } from "react-intl";

const fixedColumnsValues = ["agendamento", "veiculo", "chassi", "odometro", "horimetro", "licensePlate"];
const fixedColumnsMobileValues = ["veiculo"];

const scrollableColumnsValues = ["acoes", "revisoes", "score", "grupoManutencao", "statusGarantia", "rio", "status", "volksTotal", "ultimaRevisao", "proximaRevisao"];
const scrollableColumnsMobileValues = ["agendamento", "chassi", "odometro", "horimetro", "acoes", "revisoes", "score", "grupoManutencao", "statusGarantia", "rio", "status", "volksTotal", "ultimaRevisao", "proximaRevisao"];

const getAllColumns = (intl: IntlShape) => {
    const labels = getTableLabels(intl);
    
    return [
        {
            value: "acoes",
            label: labels.acoes,
            details: { width: 150, defaultWidth: 150, maxWidth: 150 },
        },
        {
            value: "agendamento",
            label: labels.agendamento,
            details: { width: 60, defaultWidth: 60, maxWidth: 300 },
        },
        {
            value: "veiculo",
            label: labels.veiculo,
            details: { width: 0, defaultWidth: 200, maxWidth: 350 },
        },
        {
            value: "chassi",
            label: labels.chassi,
            details: { width: 140, defaultWidth: 0, maxWidth: 350 },
        },
        {
            value: "odometro",
            label: labels.odometro,
            details: { width: 0, defaultWidth: 0, maxWidth: 350 },
        },
        {
            value: "horimetro",
            label: labels.horimetro,
            details: { width: 0, defaultWidth: 0, maxWidth: 350 },
        },
        {
            value: "licensePlate",
            label: labels.licensePlate,
            details: { width: 0, defaultWidth: 0, maxWidth: 350 },
        },
        {
            value: "revisoes",
            label: labels.revisoes,
            details: { width: 120, defaultWidth: 120, maxWidth: 150 },
        },
        {
            value: "score",
            label: labels.score,
            details: { width: 80, defaultWidth: 80, maxWidth: 130 },
        },
        {
            value: "grupoManutencao",
            label: labels.grupoManutencao,
            details: { width: 130, defaultWidth: 130, maxWidth: 150 },
        },
        {
            value: "statusGarantia",
            label: labels.statusGarantia,
            details: { width: 100, defaultWidth: 100, maxWidth: 100 },
        },
        {
            value: "status",
            label: labels.status,
            details: { width: 80, defaultWidth: 80, maxWidth: 100 },
        },
        {
            value: "rio",
            label: labels.rio,
            details: { width: 180, defaultWidth: 180, maxWidth: 180 },
        },
        {
            value: "volksTotal",
            label: labels.volksTotal,
            details: { width: 100, defaultWidth: 100, maxWidth: 120 },
        },
        {
            value: "ultimaRevisao",
            label: labels.ultimaRevisao,
            details: { width: 140, defaultWidth: 140, maxWidth: 160 },
        },
        {
            value: "proximaRevisao",
            label: labels.proximaRevisao,
            details: { width: 180, defaultWidth: 180, maxWidth: 200 },
        },
    ];
};

export const getFixedColumns = (intl: IntlShape) => {
    const allColumns = getAllColumns(intl);
    return allColumns.filter((column) => {
        if (isMobile()) return fixedColumnsMobileValues.includes(column.value);
        return fixedColumnsValues.includes(column.value);
    });
};

export const getScrollableColumns = (intl: IntlShape) => {
    const allColumns = getAllColumns(intl);
    return allColumns.filter((column) => {
        if (isMobile()) return scrollableColumnsMobileValues.includes(column.value);
        return scrollableColumnsValues.includes(column.value);
    });
};

